export default {
    state: {
        shopperLocation: [],
        shopperLocationValidated: false,
        isCompanyLocation: false,
        shopperCoupon: [],
        shopperTotal: 0,
        shopperTax: 0,
        shopperShipping: 0,
        // False when the cart needed a live shipping quote and has none.
        shopperShippingAvailable: true,
        // The server's id for the live rate in `shopperShipping`, or null.
        // Checkout names it; on a live-rate store the server charges the
        // amount it stored for the id (Jake, 2026-10-22).
        shopperShippingQuoteId: null,
        // Where a company / department store's order ships: the SERVER's
        // `checkout_quote.ship_to`, or null before it has answered (#540).
        // A shopper-address store keeps it null; its ship-to is
        // `shopperLocation`.
        shopperShipTo: null,
        // "idle" | "loading" | "loaded" | "failed" | "awaiting-department"
        // (CartShipToDestination's `state`).
        shopperShipToState: 'idle',
        shopperTaxInfo: {},
        checkoutFieldsValues: {},

        cartValid: false,
        cartLoading: false,
        shopperDetailsValid: false,
        usingCreditCard: false,

        shopperAllowance: 0,
        subTotal: 0,
    },

    mutations: {
        setShopperLocation(state, payload) {
            state.shopperLocation = payload
        },

        setShopperLocationValidated(state, payload) {
            state.shopperLocationValidated = payload
        },

        setIsCompanyLocation(state, payload) {
            state.isCompanyLocation = payload
        },

        setShopperCoupon(state, payload) {
            state.shopperCoupon = payload
        },

        setShopperTotal(state, payload) {
            state.shopperTotal = payload
        },

        setShopperTax(state, payload) {
            state.shopperTax = payload
        },

        setShopperShipping(state, payload) {
            state.shopperShipping = payload
        },

        setShopperShippingAvailable(state, payload) {
            state.shopperShippingAvailable = payload
        },

        setShopperShippingQuoteId(state, payload) {
            state.shopperShippingQuoteId = payload || null
        },

        setShopperShipTo(state, payload) {
            state.shopperShipTo = payload || null
        },

        setShopperShipToState(state, payload) {
            state.shopperShipToState = payload || 'idle'
        },

        setShopperTaxInfo(state, payload) {
            state.shopperTaxInfo = payload
        },

        setCheckoutFieldsValues(state, payload) {
            state.checkoutFieldsValues = payload
        },

        setCartValid(state, payload) {
            state.cartValid = payload
        },

        setCartLoading(state, payload) {
            state.cartLoading = payload
        },

        setShopperDetailsValid(state, payload) {
            state.shopperDetailsValid = payload
        },

        setUsingCreditCard(state, payload) {
            state.usingCreditCard = payload
        },

        setShopperAllowance(state, payload) {
            state.shopperAllowance = payload
        },

        setSubTotal(state, payload) {
            state.subTotal = payload
        }
    },

    actions: {
        setShopperLocation({ commit }, payload) {
            commit('setShopperLocation', payload)
        },

        setIsCompanyLocation({ commit }, payload) {
            commit('setIsCompanyLocation', payload)
        },

        setShopperLocationValidated({ commit }, payload) {
            commit('setShopperLocationValidated', payload)
        },

        setShopperCoupon({ commit }, payload) {
            commit('setShopperCoupon', payload)
        },

        setShopperTotal({ commit }, payload) {
            commit('setShopperTotal', payload)
        },

        setShopperTax({ commit }, payload) {
            commit('setShopperTax', payload)
        },

        setShopperShipping({ commit }, payload) {
            commit('setShopperShipping', payload)
        },

        setShopperTaxInfo({ commit }, payload) {
            commit('setShopperTaxInfo', payload)
        },

        setCheckoutFieldsValues({ commit }, payload) {
            commit('setCheckoutsFieldValues', payload)
        },

        setCartValid({ commit }, payload) {
            commit('setCartValid', payload)
        },

        setCartLoading({ commit }, payload) {
            commit('setCartLoading', payload)
        },

        setShopperDetailsValid({ commit }, payload) {
            commit('setShopperDetailsValid', payload)
        },

        setUsingCreditCard({ commit }, payload) {
            commit('setUsingCreditCard', payload)
        },

        setShopperAllowance({ commit }, payload) {
            commit('setShopperAllowance', payload)
        },
        setSubTotal({ commit }, payload) {
            commit('setSubTotal', payload)
        }
    },

    getters: {
        getShopperLocation(state) {
            return state.shopperLocation
        },

        getIsCompanyLocation(state) {
            return state.isCompanyLocation
        },

        getShopperLocationValidated(state) {
            return state.shopperLocationValidated
        },

        getShopperCoupon(state) {
            return state.shopperCoupon
        },

        getShopperTotal(state) {
            return state.shopperTotal
        },

        getShopperTax(state) {
            return state.shopperTax
        },

        getShopperShipping(state) {
            return state.shopperShipping
        },

        getShopperShippingAvailable(state) {
            return state.shopperShippingAvailable
        },

        getShopperShippingQuoteId(state) {
            return state.shopperShippingQuoteId
        },

        getShopperShipTo(state) {
            return state.shopperShipTo
        },

        getShopperShipToState(state) {
            return state.shopperShipToState
        },

        getShopperTaxInfo(state) {
            return state.shopperTaxInfo
        },

        getCheckoutFieldsValues(state) {
            return state.checkoutFieldsValues
        },

        getCartValid(state) {
            return state.cartValid
        },

        getCartLoading(state) {
            return state.cartLoading
        },

        getShopperDetailsValid(state) {
            return state.shopperDetailsValid
        },

        getUsingCreditCard(state) {
            return state.usingCreditCard
        },

        getShopperAllowance(state) {
            return state.shopperAllowance
        },

        getSubTotal(state) {
            return state.subTotal
        }

    }
}
